import React, { useState, useEffect } from 'react';
import { AccordionItem as ChromaAccordionItem } from '@iag-packages/chroma-react/lib/patterns';

interface AccordionProps {
  activeItems?: number[];
  [propName: string]: unknown;
}

export const AccordionItem = ({ ...props }: AccordionProps) => {
  const { activeItems: initialActiveItems, ...rest } = props;
  const [activeItems, setActiveItems] = useState<number[]>(
    initialActiveItems || []
  );

  useEffect(() => {
    setActiveItems(initialActiveItems || []);
  }, [initialActiveItems]);

  const toggleItem = (itemIndex: number) => {
    const itemInArray = activeItems.findIndex(
      (item: number) => item === itemIndex
    );

    if (itemInArray === -1) {
      const newArr = [...activeItems, itemIndex];
      setActiveItems(newArr);
    } else {
      const newArr = activeItems.filter(
        (_item: number, index: number) => index !== itemInArray
      );
      setActiveItems(newArr);
    }
  };

  return (
    /* eslint-disable react/jsx-props-no-spreading */
    <ChromaAccordionItem
      {...rest}
      active={activeItems}
      toggleItem={toggleItem}
    />
  );
};

export default AccordionItem;
